/**
 * Mobile nav drill-down — smooth lateral panels (transform only)
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-mobile-nav-drill]';
  var OPEN_SEL = '[data-drill-open]';
  var BACK_SEL = '[data-drill-back]';
  var SWIPE_MIN = 60;

  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function raf(fn) {
    window.requestAnimationFrame(fn);
  }

  function MobileNavDrill(root) {
    this.root = root;
    this.drawer = closest(root, '[data-mobile-nav-panel]');
    this.stack = [];
    this.animating = false;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.tracking = false;
    this.onClick = this.onClick.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.syncPanelBackground();
    this.root.addEventListener('click', this.onClick);
    this.root.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.root.addEventListener('touchend', this.onTouchEnd, { passive: true });
  }

  MobileNavDrill.prototype.syncPanelBackground = function () {
    var source = this.drawer || this.root;
    var bg = window.getComputedStyle(source).backgroundColor;
    if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') {
      bg = window.getComputedStyle(document.body).backgroundColor || '#fff';
    }
    var panels = this.root.querySelectorAll('[data-drill-panel]');
    for (var i = 0; i < panels.length; i++) {
      panels[i].style.backgroundColor = bg;
      panels[i].setAttribute('aria-hidden', 'true');
      if ('inert' in panels[i]) panels[i].inert = true;
    }
    var backButtons = this.root.querySelectorAll('.mobile-nav-drill__back');
    for (var j = 0; j < backButtons.length; j++) {
      backButtons[j].style.backgroundColor = bg;
    }
  };

  MobileNavDrill.prototype.onClick = function (event) {
    var openBtn = closest(event.target, OPEN_SEL);
    if (openBtn && this.root.contains(openBtn)) {
      event.preventDefault();
      event.stopPropagation();
      this.openPanel(openBtn.getAttribute('data-drill-open'));
      return;
    }

    var backBtn = closest(event.target, BACK_SEL);
    if (backBtn && this.root.contains(backBtn)) {
      event.preventDefault();
      event.stopPropagation();
      this.goBack();
    }
  };

  MobileNavDrill.prototype.onTouchStart = function (event) {
    if (!event.touches || event.touches.length !== 1) return;
    if (!this.stack.length || this.animating) return;
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
    this.tracking = true;
  };

  MobileNavDrill.prototype.onTouchEnd = function (event) {
    if (!this.tracking || !event.changedTouches || !event.changedTouches.length) {
      this.tracking = false;
      return;
    }
    this.tracking = false;
    if (!this.stack.length || this.animating) return;

    var dx = event.changedTouches[0].clientX - this.touchStartX;
    var dy = event.changedTouches[0].clientY - this.touchStartY;
    if (dx >= SWIPE_MIN && Math.abs(dx) > Math.abs(dy)) {
      this.goBack();
    }
  };

  MobileNavDrill.prototype.scrollPanelTop = function (panel) {
    if (!panel) return;
    panel.scrollTop = 0;
    raf(function () {
      panel.scrollTop = 0;
      raf(function () {
        panel.scrollTop = 0;
      });
    });
  };

  MobileNavDrill.prototype.openPanel = function (id) {
    if (!id || this.animating) return;
    var panel = document.getElementById(id);
    if (!panel || !this.root.contains(panel)) return;
    if (panel.classList.contains('is-open')) return;

    this.animating = true;
    panel.setAttribute('aria-hidden', 'false');
    if ('inert' in panel) panel.inert = false;
    this.scrollPanelTop(panel);

    var self = this;
    raf(function () {
      raf(function () {
        panel.classList.add('is-open');
        self.stack.push(panel);
        self.syncState();
        self.scrollPanelTop(panel);
        self.animating = false;
      });
    });
  };

  MobileNavDrill.prototype.goBack = function () {
    if (!this.stack.length || this.animating) return;
    this.animating = true;

    var panel = this.stack.pop();
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if ('inert' in panel) panel.inert = true;
    panel.style.removeProperty('pointer-events');
    panel.style.removeProperty('z-index');
    this.syncState();

    var self = this;
    var finished = false;
    var done = function (event) {
      if (finished) return;
      if (event && event.target !== panel) return;
      if (event && event.propertyName && event.propertyName !== 'transform') return;
      finished = true;
      panel.removeEventListener('transitionend', done);
      self.animating = false;
    };

    panel.addEventListener('transitionend', done);
    window.setTimeout(done, 300);
  };

  MobileNavDrill.prototype.reset = function () {
    this.animating = false;
    while (this.stack.length) {
      var panel = this.stack.pop();
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      if ('inert' in panel) panel.inert = true;
      panel.style.removeProperty('pointer-events');
      panel.style.removeProperty('z-index');
    }
    this.syncState();
    if (this.root) this.root.style.height = '';
  };

  MobileNavDrill.prototype.syncState = function () {
    var drilling = this.stack.length > 0;
    this.root.classList.toggle('is-drilling', drilling);
    this.root.setAttribute('data-drill-level', String(this.stack.length + 1));

    if (this.drawer) {
      this.drawer.classList.toggle('is-drill-locked', drilling);
      if (drilling) {
        this.drawer.scrollTop = 0;
        var offset = this.contentOffset();
        var available = this.drawer.clientHeight - offset;
        this.root.style.height = available > 0 ? available + 'px' : '';
      } else {
        this.root.style.height = '';
      }
    }

    var topIndex = this.stack.length - 1;
    this.stack.forEach(function (panel, index) {
      panel.style.zIndex = String(5 + index);
      if (index === topIndex) {
        panel.style.removeProperty('pointer-events');
      } else {
        panel.style.pointerEvents = 'none';
      }
    });
  };

  MobileNavDrill.prototype.contentOffset = function () {
    if (!this.drawer) return 0;
    var actions = this.drawer.querySelector('.site-header-actions');
    if (!actions) return 0;
    var style = window.getComputedStyle(actions);
    var mt = parseFloat(style.marginTop) || 0;
    var mb = parseFloat(style.marginBottom) || 0;
    return Math.ceil(actions.getBoundingClientRect().height + mt + mb);
  };

  MobileNavDrill.prototype.destroy = function () {
    this.reset();
    this.root.removeEventListener('click', this.onClick);
    this.root.removeEventListener('touchstart', this.onTouchStart);
    this.root.removeEventListener('touchend', this.onTouchEnd);
  };

  var instance = null;

  function init() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;
    if (instance) instance.destroy();
    instance = new MobileNavDrill(root);
  }

  function resetOnClose() {
    if (instance) instance.reset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('click', function (event) {
    if (closest(event.target, '[data-mobile-nav-close], [data-mobile-nav-overlay]')) {
      window.setTimeout(resetOnClose, 280);
    }
  });

  var nav = document.querySelector('[data-mobile-nav]');

  function syncOpenClass() {
    if (!nav) return;
    var open = nav.getAttribute('data-open') === 'true';
    document.body.classList.toggle('mobile-nav-open', open);
    document.documentElement.classList.toggle('mobile-nav-open', open);
    if (!open) resetOnClose();
  }

  if (nav && window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'data-open') {
          syncOpenClass();
          break;
        }
      }
    }).observe(nav, { attributes: true });
    syncOpenClass();
  }
})();
